/**
 * PropertyCardSkeleton
 * -------------------------------------------------------------
 * Elegant shimmer skeleton mirroring the PropertyCard layout so
 * loading states never feel jarring. Uses the `.skeleton-shimmer`
 * utility from index.css.
 */
export default function PropertyCardSkeleton({ count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-2xl border border-slate-200/60 bg-white"
          data-testid="property-card-skeleton"
        >
          <div className="relative aspect-[4/3] skeleton-shimmer">
            <div className="absolute left-4 top-4 h-6 w-20 rounded-full bg-white/80" />
            <div className="absolute right-4 top-4 h-10 w-10 rounded-full bg-white/80" />
            <div className="absolute bottom-4 left-4 h-9 w-28 rounded-xl bg-white/85" />
          </div>

          <div className="space-y-3 p-5">
            <div className="h-5 w-3/4 rounded-md skeleton-shimmer" />
            <div className="h-4 w-1/2 rounded-md skeleton-shimmer" />

            <div className="flex items-center gap-4 pt-2">
              <div className="h-4 w-14 rounded-md skeleton-shimmer" />
              <div className="h-4 w-14 rounded-md skeleton-shimmer" />
              <div className="h-4 w-16 rounded-md skeleton-shimmer" />
            </div>

            <div className="h-4 w-2/5 rounded-md skeleton-shimmer" />
          </div>
        </div>
      ))}
    </>
  );
}
